'use client';

import Camera from '@/assets/svg/icons/camera.svg';
import FeaturedIcon from "../common/icons/featured_icon";
import classes from "./public_header.module.css";
import link_classes from "./public_header_item.module.css";
import PublicHeaderItem from "./public_header_item";
import { useQuery } from '@tanstack/react-query';
import { getProviderTypes } from '@/utils/http';
import { forwardRef, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import Link from 'next/link';
import { usePathname } from "next/navigation";
import CustomSVG from '../common/svg';
import ChevronDown from '@/assets/svg/icons/chevron-down.svg';
import ChevronUp from '@/assets/svg/icons/chevron-up.svg';

const CustomToggle = forwardRef(function CustomToggle({ children, onClick, path, active }, ref) {
    return (
        <div ref={ref} className="d-flex h-100 align-items-center pointer" onClick={(e) => {e.preventDefault();}}>
            <Link href={"/szolgaltatok"} className={`show-on-pc-480 h-100 d-flex flex-row align-items-center gap-1 ${link_classes.link} ${(path.startsWith("/szolgaltatok")) ? link_classes.active : ''}`} onClick={onClick} >
                Szolgáltatók
                <CustomSVG className="stroke-gray-700" SvgFunction={active ? ChevronUp : ChevronDown} height={24} width={24} />
            </Link> 
        </div>
    )
});

export default function PublicHeaderProviderDropdown({}) {
    const path = usePathname();
    const [isOpen, setIsOpen] = useState(false);

    const handleMouseEnter = () => { setIsOpen(true); };
    const handleMouseLeave = () => { setIsOpen(false); };

    const { data: provider_types } = useQuery({
        queryKey: ['provider-types'],
        queryFn: () => getProviderTypes()
    });

    if(!provider_types) return <PublicHeaderItem icon={<FeaturedIcon size={"md"} color={"gray"} icon={Camera} />} href="/szolgaltatok" >Szolgáltatók</PublicHeaderItem>

    return <Dropdown show={isOpen} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} className='h-100' >
        <Dropdown.Toggle as={CustomToggle} active={isOpen} path={path} onClick={handleMouseLeave} />
        <Dropdown.Menu onMouseEnter={handleMouseEnter} className={`${classes["provider-dropdown"]}`}>
            <div className={`${classes["provider-dropdown-inner"]}`}>
                {provider_types && provider_types.length > 0 && provider_types.map(p => <div key={`nav-provider-item-${p.id}`} className={`${classes["provider-dropdown-element"]}`}>
                    <Link href={`/${p._url}`} title={p.name} className={`${classes["provider-dropdown-link"]} color-gray-700 text-md-medium`} onClick={handleMouseLeave} >{p.name}</Link>
                </div>)}
            </div>
        </Dropdown.Menu>
    </Dropdown>
}